import Heading from 'components/atoms/Heading/Heading';
import ReferralsMetrics from 'components/molecules/ReferralsMetrics/ReferralsMetrics';
import LifetimeReferralsStats from 'components/organisms/LifetimeReferralsStats/LifetimeReferralsStats';
import ReferAFriend from 'components/organisms/ReferAFriend/ReferAFriend';
import { ReferralsQuery } from 'components/pages/Referrals/__generated__/ReferralsQuery.graphql';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import Back from './assets/back.svg';
import classes from './Referrals.module.scss';

export type Props = {};

export default function Referrals({}: Props) {
  const data = useLazyLoadQuery<ReferralsQuery>(
    graphql`
      query ReferralsQuery {
        referralHistory {
          ...ReferralsMetrics_referralsRef
          ...LifetimeReferralsStats_referralsRef
        }
        ...ReferAFriend_referralsRef
      }
    `,
    {},
    { fetchPolicy: 'store-and-network' },
  );
  const router = useRouter();

  const [showMetrics, setShowMetrics] = useState(false);

  return (
    <div className={classes.root}>
      <div className={classes.intro}>
        <Back className={classes.back} onClick={() => router.back()} />
        <Heading level={1} className={classes.title}>
          Refer A Friend
        </Heading>
      </div>
      <ReferAFriend
        referralsRef={data}
        className={classes.referAFriend}
        onOpenMetrics={(e) => {
          e.preventDefault();
          setShowMetrics(true);
        }}
      />
      <LifetimeReferralsStats referralsRef={data.referralHistory} />
      {showMetrics && (
        <ReferralsMetrics
          referralsRef={data.referralHistory}
          onClose={() => setShowMetrics(false)}
        />
      )}
    </div>
  );
}
